import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { SiteHeader } from '../components/SiteHeader';
import { Hero } from '../components/Hero';
import { PathBridge } from '../components/PathBridge';
import { SiteFooter } from '../components/SiteFooter';
import { AboutUlm } from '../components/discover/AboutUlm';
import { ClassesSection } from '../components/discover/ClassesSection';
import { TrainingSection } from '../components/discover/TrainingSection';
import { BaseFinder } from '../components/discover/BaseFinder';
import { FaqSection } from '../components/discover/FaqSection';
import { ActionsSection } from '../components/member/ActionsSection';
import { SafetySection } from '../components/member/SafetySection';
import { AgendaSection } from '../components/member/AgendaSection';
import { NewsSection } from '../components/member/NewsSection';
import { MemberAccess } from '../components/member/MemberAccess';
import type { PathKey } from '../types/content';
interface HomeProps {
  defaultPath: PathKey;
}
export function Home({
  defaultPath
}: HomeProps) {
  const [path, setPath] = useState<PathKey>(defaultPath);
  return <div className="w-full bg-white" data-id="element-257" data-mp="2vvlw0hino85h">
      <SiteHeader path={path} onPathChange={setPath} data-id="element-258" data-mp="2qy2i5ipvdxe2" />
      <main data-id="element-259" data-mp="2qwsjarb70l6d">
        <Hero path={path} onPathChange={setPath} data-id="element-260" data-mp="2r0gavkx2uxig" />

        <AnimatePresence mode="wait" initial={false} data-id="element-261" data-mp="2mvyulvpxf2cf">
          <motion.div key={path} initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -8
        }} transition={{
          duration: 0.22,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-262" data-mp="2hxx9z6cuquyu">
            {path === 'decouverte' ? <>
                <AboutUlm data-id="element-263" data-mp="239ath1bhnx61" />
                <ClassesSection data-id="element-264" data-mp="23a2ghnr0smkp" />
                <TrainingSection data-id="element-265" data-mp="236y5o7j1usl2" />
                <BaseFinder data-id="element-266" data-mp="1z762698ijcmk" />
                <FaqSection data-id="element-267" data-mp="1z6eb9bpv232m" />
              </> : <>
                <ActionsSection data-id="element-268" data-mp="1u82xipwg38f4" />
                <SafetySection data-id="element-269" data-mp="1u8usbyi7x24c" />
                <AgendaSection data-id="element-270" data-mp="1kkqm1c4sw8cw" />
                <NewsSection data-id="element-271" data-mp="1kkh5ef5nbdjv" />
                <MemberAccess data-id="element-272" data-mp="1kj5uzwhp37js" />
              </>}
          </motion.div>
        </AnimatePresence>

        <PathBridge path={path} onPathChange={setPath} data-id="element-273" data-mp="1onn7rbpn0kl2" />
      </main>
      <SiteFooter data-id="element-274" data-mp="1anktdzgjg9ak" />
    </div>;
}